import { clientHost } from '@/config';
import request from '@/services/request';

export const signUp = payload => request.post('/auth/sign-up', payload);

export const sendCompleteJoinRequest = async (
  { claimToken, password },
) => request.post('/join/complete', {
  token: claimToken,
  password,
});

export const getJoinRequest = async token => request.get(`/join/${token}`);

export const loginUser = async ({ email, password }) => request.post('/auth/login', {
  email,
  password,
});

export const restorePassword = async ({ email }) => request.post('/auth/password/restore', { email });

// export const getRestorePasswordRequest = async ({ token }) => request.get(`/auth/restore-password/${token}`);

// export const sendCompleteRestorePassword = async (
//   { claimToken, password },
// ) => request.post('/auth/restore-password/complete', {
//   token: claimToken,
//   password,
// });

export const logoutUser = async () => request.post('/auth/logout');

export const getCurrentUser = async () => request.get('/auth/me');

export const getClientToken = async () => request.get('/auth/token');

export const instantSignUp = formData => request.post('auth/sign-up/instant', formData);

export const checkIfUserExists = email => request.get('community/check-user', { params: { email } });

// export const setNewPassword = body => request.put('/auth/password', body);

export const setReferer = referrer => request.post('/auth/referrer', { referrer });

export const test = () => request.get('/test');

export const makeUserACreator = () => request.put('profile/make-creator');

export const claimUsername = username => request.post('auth/username/claim', { username });

export const checkUsernameAvailability = username => request.get(`auth/username/${username}/availability`);

export const getUsername = id => request.get(`auth/username/${id}`);

export const changeUsername = data => request.put('auth/username', data);

export const getNodebbToken = () => request.get('/auth/me/nodebb-token');
export const setNodebbToken = token => fetch(`${clientHost}/nodebb-integration?nodebbToken=${token}`);
export const authenticateNodebb = async () => {
  const { data } = await getNodebbToken();
  await setNodebbToken(data.token);
};
export const deAuthenticateNodebb = () => fetch(`${clientHost}/nodebb-integration?deleteCookie=1`);

/**
 * Get default data to start app tier subscription process
 * @param {string} tierKey
 * @param {string} paymentIntervalKey
 */
export const appTierSubscriptionSetup = (
  tierKey,
  paymentIntervalKey,
  currency,
) => request.post('/auth/me/app-tier-subscriptions/setup', {
  tierKey,
  paymentIntervalKey,
  currency,
});

/**
 * Create app tier subscription for the user
 * @param {string} priceId
 * @param {Object} options
 * @param {Object} options.promotionCode
 * @param {Object} options.paymentMethodId
 */
export const appTierSubscriptionCheckout = (
  priceId,
  options,
) => request.post('/auth/me/app-tier-subscriptions/checkout', {
  ...options,
  priceId,
});

export const getAvailableTierGiftCampaign = () => request.get('/auth/me/tier-gift-campaigns/available');

export const applyToTierGiftCampaign = tierGiftCampaignId => request.post(`/auth/me/tier-gift-campaigns/${tierGiftCampaignId}/apply`);

export const applyTemplate = () => request.post('/auth//me/apply-template');
